
import { useBusinessData } from './useBusinessData';
import { useFormState } from './useFormState';
import { useFormHandlers } from './useFormHandlers';
import { useFormSave } from './useFormSave';
import { useFormChanges } from './useFormChanges';
import { useCalendarState } from './useCalendarState';

export const useBusinessForm = (businessId?: string) => {
  // Get business data
  const { business } = useBusinessData(businessId);
  
  // Calendar state
  const { calendarOpen, setCalendarOpen, date, setDate } = useCalendarState(business);
  
  // Form state and changes
  const { 
    formData, 
    initialFormData, 
    setFormData, 
    displayNameManuallyEdited, 
    setDisplayNameManuallyEdited 
  } = useFormState(business);
  
  // Track form changes
  const { formChanged } = useFormChanges(formData, initialFormData);
  
  // Form handlers
  const { 
    handleInputChange, 
    handleSelectChange, 
    handleDateSelect,
    handleCancel 
  } = useFormHandlers({
    formData,
    setFormData,
    initialFormData,
    formChanged,
    setDisplayNameManuallyEdited,
    setCalendarOpen,
    setDate
  });
  
  // Save function
  const { handleSave } = useFormSave(businessId, formData, formChanged);

  return {
    business,
    formData,
    formChanged,
    displayNameManuallyEdited,
    calendarOpen,
    setCalendarOpen,
    date,
    handleInputChange,
    handleSelectChange,
    handleDateSelect,
    handleCancel,
    handleSave
  };
};

export default useBusinessForm;
